import { ApiBase } from 'utils/api';
import { CompanyData, CompanyModel } from 'models/CompanyModel';
import { UserData } from 'models/UserModel';


export default class AuthApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    user = () => this.base.axios.get('/api/user');

    csrf = () => this.base.axios.get('/sanctum/csrf-cookie');

    register = async (company: CompanyData, admin: UserData) => {
        await this.csrf();

        return this.base.axios.post('/register', {...company, admin});
    };

    requestInvite = (user: UserData) => this.base.axios
        .post('/request-invite', user);

    rename = (data: any) => this.base.axios
        .put('/api/user/name', data);

    setSettings = (data: any) => this.base.axios
        .put('/api/user/settings', data);

    updatePassword = (password_old: string, password: string, password_confirmation: string) => {
        return this.base.axios.put('/api/user/password', {
            password_old,
            password,
            password_confirmation,
        });
    };

    updateCompany = (data: CompanyModel) => {
        return this.base.axios.put(`/api/user/company`, data);
    };

    login = async (email: string, password: string, remember: boolean) => {
        await this.csrf();

        let userAgent = navigator.userAgent;
        let device_name = 'Browser';

        if (userAgent.match(/chrome|chromium|crios/i)) {
            device_name = 'Chrome';
        } else if (userAgent.match(/firefox|fxios/i)) {
            device_name = 'Firefox';
        } else if (userAgent.match(/safari/i)) {
            device_name = 'Safari';
        } else if (userAgent.match(/opr\//i)) {
            device_name = 'Opera';
        } else if (userAgent.match(/edg/i)) {
            device_name = 'Edge';
        }

        return this.base.axios.post<any>('/token/login',
            {
                email,
                password,
                remember,
                device_name,
            }
        )
    };

    forgotPassword = async (email: string) => {
        await this.csrf();

        return this.base.axios
            .post('/forgot-password', { email })
    }

    resetPassword = async (email: string, password: string, password_confirmation: string, token: string) => {
        await this.csrf();

        return this.base.axios
            .post('/reset-password', { email, password, password_confirmation, token })
    }

    finishInvite = async (email: string, password: string, password_confirmation: string, token: string) => {
        await this.csrf();

        return this.base.axios
            .post('/finish-invite', { email, password, password_confirmation, token })
    }

    resendEmailVerification = async () => {
        await this.csrf();

        return this.base.axios
            .post('/email/verification-notification')
    }

    logout = async () => {
        await this.csrf();

        return this.base.axios.post('/token/logout')
    };
}
